import { Directive } from '@angular/core';
import { TextInputComponent } from '@thiememeulenhoff/albert';
import { BaseValueAccessorDirective, valueAccessorProvider } from './base';

@Directive({
  selector:
    // eslint-disable-next-line @angular-eslint/directive-selector
    'a-text-area[ngModel],a-text-area[formControl],a-text-area[formControlName]',
  providers: [valueAccessorProvider(TextAreaValueAccessorDirective)],
})
export class TextAreaValueAccessorDirective extends BaseValueAccessorDirective<
  TextInputComponent,
  string
> {}
